package com.exura.features.legacyplans.domain.usecase

import com.exura.features.legacyplans.LegacyPlansApi
import com.exura.features.legacyplans.api.dto.IssueViaReceiverIdRequest
import com.exura.features.legacyplans.api.dto.IssueViaReceiverIdResult
import dev.gitlive.firebase.functions.FirebaseFunctions

class DistributeDetailedPlanViaReceiverIdUseCase(
    private val functions: FirebaseFunctions,
) {

    suspend operator fun invoke(
        detailedPlanId: String,
        receiverId: String,
    ): Result<Unit> = runCatching {
        val issueViaReceiver = functions.httpsCallable(LegacyPlansApi.ISSUE_VIA_RECEIVER_ID)
        val result = issueViaReceiver(
            IssueViaReceiverIdRequest(
                detailedPlanId = detailedPlanId,
                receiverId = receiverId,
            )
        )
        val data = result.data<IssueViaReceiverIdResult>()
    }
}
